import React from "react";
import check from "../../images/check.svg";
import crose from "../../images/crose.svg";
import square from "../../images/square.png";
import { BiPlus } from "react-icons/bi";
import { Link } from "react-router-dom";

const PricingTableComponent2 = () => {
  return (
    <section className="troo-da-pricing" id="troo-da-pricing">
      <div className="container">
        <div className="row">
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla first-pri"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  12<span>/ per month</span>
                </div>
              </div>
              <h2>Starter Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla second-pri"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  49<span>/ per month</span>
                </div>
              </div>
              <h2>Premium Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla last-pric"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  99<span>/ per month</span>
                </div>
              </div>
              <h2>Professional Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla last-pric"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  129<span>/ per month</span>
                </div>
              </div>
              <h2>Starter Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla last-pric"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  149<span>/ per month</span>
                </div>
              </div>
              <h2>Premium Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
          <div className="col-xl-4 col-lg-6 mb-4 col-md-6 col-sm-12 col-xs-12">
            <div className="pricing">
              <div className="price-cricla last-pric"></div>
              <div className="price-rupes">
                <span>$</span>
                <div className="price">
                  199<span>/ per month</span>
                </div>
              </div>
              <h2>Professional Plan</h2>
              <ul>
                <li>
                  <img src={check} alt="check" />
                  Faster Measurement
                </li>
                <li>
                  <img src={check} alt="check" />
                  Determine ground-level squares
                </li>
                <li>
                  <img src={check} alt="check" />
                  Multiply the ground-level squares
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Fibre sheet roofing designs
                </li>
                <li>
                  <img src={crose} alt="crose" />
                  Plastic Roofing Sheet Design
                </li>
              </ul>
              <div className="pric-btn">
                <Link href="#" className="custom-btn btn-13">
                  <BiPlus className="plus" />
                  See All Feedback
                </Link>
              </div>
              <div className="trign-pri">
                <img src={square} alt="square" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PricingTableComponent2;
